import script from "./DocItemMemo.vue?vue&type=script&setup=true&lang=js"
export * from "./DocItemMemo.vue?vue&type=script&setup=true&lang=js"

import "./DocItemMemo.vue?vue&type=style&index=0&id=f58a576a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f58a576a"]])

export default __exports__